import Classification from "../../../data/fieldRenderers/Classification";
import Date from "../../../data/fieldRenderers/Date";
import ID from "../../../data/fieldRenderers/ID";
import Tag from "../../../data/fieldRenderers/Tag";
import type { FieldRenderers } from "../../../data/types";
import type { DataType } from "../../jobs/data/fields";

const fieldRenderers: FieldRenderers<DataType> = {
  Date,
  ID,
  Tag,
  Classification,
};

export default fieldRenderers;
